import F84Game from "../Game";
import GameConfig from "../core/data/GameConfig";
import BaseURL from "../utils/BaseURL";
import LoadingContainer from "../ui/LoadingContainer";
import UIFactory from "../utils/UIFactory";
import Strings from "../core/data/Strings";
import Fonts from "../utils/Fonts";
import LoaderScene from "./LoaderScene";
import ScaleManager from "../core/ScaleManager";
import GameColors from "../GameColors";

export default class PreloaderScene extends LoaderScene {
    private _onResize: () => any;
    private _loadingContainer: LoadingContainer;
    private _loadingText: Phaser.GameObjects.Text;
    // private _footer: Phaser.GameObjects.Container;
    // private _footerText: Phaser.GameObjects.Text;
    // private _footerImage: Phaser.GameObjects.Image;
    private destinationScene: string;
    logoContainer: Phaser.GameObjects.Container;
    leftClutter: Phaser.GameObjects.Image;
    rightClutter: Phaser.GameObjects.Image;
    introComplete: boolean;

    init(data: { destinationScene: string }): void {
        this.destinationScene = "SplashScene";
        if (data.destinationScene) this.destinationScene = data.destinationScene;
        super.init(data);
    }

    public preload(): void {
        super.preload();
        this.introComplete = false;

        const bg = this.add.image(0, 0, "splashbg");
        const leftClutter = this.leftClutter = this.add.image(0, 0, "leftClutter");
        const rightClutter = this.rightClutter = this.add.image(0, 0, "rightClutter");

        const logoContainer = this.logoContainer = this.add.container();
        const logoBacker =this.add.image(0,0,"loadingLogoBacker");
        const logo = this.add.image(0, 0, "splashLogo").setScale(0.9);
        const textBacker = this.add.image(0, 0, "splashTextBacker");
        const sparkleSpine = this.add.spine(0, 0, "splash-sparkle", "idle", true);
        sparkleSpine.timeScale = 0.75;
        const sparklecontainer = this.add.spineContainer(0, 0, sparkleSpine);
        logoContainer.add([logoBacker, logo, textBacker, sparklecontainer]);

        this._loadingText = this.add.text(0, 0, Strings.get("LoadingAssets"), {
            fontFamily: Fonts.DefaultFont,
            fontSize: "36px",
            color: GameColors.BLACK,
        });
        this._loadingText.visible = false;

        this._loadingContainer = new LoadingContainer(this);
        this.add.existing(this._loadingContainer);

        F84Game.Instance.loadBatches.loadBatchesForScene(this, this.destinationScene);

        this.loadUpdate();
        this.addResize(() => {
            ScaleManager.ScaleBackgroundFromZone(bg, this.viewport);
            this.alignIn.Center(bg, this.viewport);
            this.alignIn.LeftCenter(leftClutter, this.viewport, 50, 0);
            this.alignIn.RightCenter(rightClutter, this.viewport, 50, 0);
            this.alignIn.Center(logoContainer, this.viewport, 0, -50);
            this.alignIn.TopCenter(logo, logoBacker, 0, -20);
            this.alignIn.BottomCenter(textBacker, logoBacker, 0, 85);
            this.alignIn.BottomCenter(this._loadingText , this.viewport, 0, -90);
            this.alignTo.BottomCenter(this._loadingContainer, this._loadingText, 0, 20);
        });

        // Build in anim
        logoContainer.setScale(0);
        leftClutter.x -= leftClutter.width;
        rightClutter.x += rightClutter.width;
        this._loadingContainer.y += 200;

        this.tweens.add({
            targets: logoContainer,
            scale: 1,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Back.Out,
        });

        this.tweens.add({
            targets: leftClutter,
            x: leftClutter.x + leftClutter.width,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Back.Out,
        });

        this.tweens.add({
            targets: rightClutter,
            x: rightClutter.x - rightClutter.width,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Back.Out,
        });

       this.tweens.add({
            targets: this._loadingContainer,
            y: this._loadingContainer.y - 200,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Quadratic.Out,
            onComplete: () => {
                this.introComplete = true;
            }
        });
    }

    create(): void {
        super.create();
        this.next();
    }

    loadUpdate(): void {
        const percentComplete = this.load.totalComplete / this.load.totalToLoad;
        this._loadingContainer.setLoadPercent(percentComplete);
    }

    resize(): void {
        super.resize();
        if (this._onResize != null) this._onResize();
        // if (this._footer) this.alignIn.BottomCenter(this._footer, this.viewport);
    }

    onLoadComplete(): void {
        if (this._loadingContainer) this._loadingContainer.setLoadComplete();
        this.resize();
    }

    next(): void {
        if (!this.introComplete) {
            this.time.addEvent({
                delay: 100,
                callback: () => this.next(),
            });
            return;
        }
        GameConfig.loadConfigFile(this.cache, "gameConfig");
        this.tweens.add({
            targets: this.logoContainer,
            scale: 0,
            duration: 400,
            ease: Phaser.Math.Easing.Back.In,
        });

        this.tweens.add({
            targets: this.leftClutter,
            x: this.leftClutter.x - this.leftClutter.width,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Back.In,
        });

        this.tweens.add({
            targets: this.rightClutter,
            x: this.rightClutter.x + this.rightClutter.width,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Back.In,
        });

        this.tweens.add({
            targets: this._loadingContainer,
            y: this._loadingContainer.y + 200,
            duration: 400,
            delay: 50,
            ease: Phaser.Math.Easing.Quadratic.In,
            onComplete: () => this.scene.start(this.destinationScene)
        });
    }

    shutdown(): void {
        this._onResize = null;
        // if (this._footerText) this._footerText.destroy();
        // this._footerText = null;
        // if (this._footerImage) this._footerImage.destroy();
        // this._footerImage = null;
        super.shutdown();
    }
}
